import type { ServerError } from 'models';

export const handleTransferError = (
    err: ServerError,
    isDeposit: boolean,
): { errorTitle: string | undefined; errorMessage: string | undefined } => {
    let errorTitle: string | undefined = isDeposit ? 'Your Deposit Failed' : 'Your Withdrawal Failed';
    let errorMessage: string | undefined;

    if (!err?.error) {
        return { errorTitle, errorMessage };
    }

    if (!!err.error.message) {
        errorTitle = err.error.message;
    }

    if (!!err.error.details) {
        errorMessage = err.error.details;
    }

    return { errorTitle, errorMessage };
};
